// extracted by mini-css-extract-plugin
export default {"survey-monkey-button":"styles__survey-monkey-button--Vr91x"};